import { useTranslation } from 'react-i18next';
import {
  SubformComponent,
  SubCardFieldsComponent,
  SubModule,
} from '@/modules/admin/audits/components/submodules/types';
import { LineText } from '@common/components/fragments/LineText';
import AuditsExportsCadrageDendreoExport from '@/app/spraypaint/audits/exports/AuditsExportsCadrageDendreoExport';

export const jsonApiType = AuditsExportsCadrageDendreoExport.jsonapiType;

export type Values = Record<string, never>;

export const defaultValues: Values = {};

function createExportStrategy(): AuditsExportsCadrageDendreoExport {
  return new AuditsExportsCadrageDendreoExport();
}

export const FormComponent: SubformComponent = () => null;

export const CardFieldsComponent: SubCardFieldsComponent<
  AuditsExportsCadrageDendreoExport
> = () => {
  const { t } = useTranslation();

  return (
    <LineText
      label={t('activerecord.attributes.audits/export.export_strategy', {
        ns: 'rails',
      })}
      value={t('activerecord.models.audits/exports/cadrage_dendreo_export', {
        ns: 'rails',
      })}
    />
  );
};

export const AuditsExportsCadrageDendreoExportSubmodule: SubModule<
  Values,
  AuditsExportsCadrageDendreoExport
> = {
  jsonApiType,
  defaultValues,
  FormComponent,
  CardFieldsComponent,
  createExportStrategy,
};
